import { Core } from "@faire/design-tokens";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import React from "react";

export const HorizontalLineWithColor: React.FC = () => {
  return <HorizontalLine color={Core.border.muted} />;
};
